var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgySi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C20.9893 9.95721 20.284 7.97883 19 6.39L24 1.46L22.54 0L17.61 5C16.0162 3.72948 14.0383 3.03761 12 3.03761C9.96174 3.03761 7.98383 3.72948 6.39 5L1.46 0L0 1.46L5 6.39C3.72948 7.98383 3.03761 9.96174 3.03761 12C3.03761 14.0383 3.72948 16.0162 5 17.61L0 22.54L1.46 24L6.39 19C7.98383 20.2705 9.96174 20.9624 12 20.9624C14.0383 20.9624 16.0162 20.2705 17.61 19L22.54 24L24 22.54L19 17.61C20.284 16.0212 20.9893 14.0428 21 12ZM12 19C10.6155 19 9.26215 18.5895 8.11101 17.8203C6.95986 17.0511 6.06266 15.9579 5.53284 14.6788C5.00303 13.3997 4.86441 11.9922 5.1345 10.6344C5.4046 9.2765 6.07128 8.02922 7.05025 7.05025C8.02922 6.07128 9.2765 5.4046 10.6344 5.1345C11.9922 4.86441 13.3997 5.00303 14.6788 5.53284C15.9579 6.06266 17.0511 6.95986 17.8203 8.11101C18.5895 9.26215 19 10.6155 19 12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgySi);
export default __webpack_public_path__ + "static/media/SGY-SI.10fa5ca7df29416fa29ef4c34afa5b46.svg";
export { ForwardRef as ReactComponent };